module.exports = __webpack_public_path__ + "static/media/Share-icon.847c389f.svg";